import { extensionForMime, formatDuration } from '@/features/recorder/model/media'
import { useT } from '@/shared/i18n'

interface RecorderStatusProps {
  status: 'idle' | 'requesting' | 'ready' | 'recording' | 'paused' | 'finished' | 'error'
  seconds: number
  errorText: string | null
  mime: string | undefined
}

export function RecorderStatus({ status, seconds, errorText, mime }: RecorderStatusProps) {
  const t = useT()
  if (status === 'idle') return null
  if (status === 'error') {
    return (
      <div role="alert" className="rounded-lg border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm leading-6 text-destructive">
        {errorText}
      </div>
    )
  }

  const label = status === 'requesting' ? t.common.requesting
    : status === 'ready' ? t.common.ready
      : status === 'recording' ? t.common.recording
        : status === 'paused' ? t.common.paused
          : t.common.finished

  return (
    <div className="grid gap-3 rounded-xl border bg-background/70 p-4 sm:grid-cols-2">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground">{t.common.timer}</div>
        <div className="mt-1 font-mono text-3xl font-bold tabular-nums">{formatDuration(seconds)}</div>
      </div>
      <div className="sm:text-right">
        <div className="text-sm font-medium" role="status" aria-live="polite">{label}</div>
        {mime && <div className="mt-1 text-xs text-muted-foreground">{t.common.format}: {extensionForMime(mime).toUpperCase()}</div>}
      </div>
    </div>
  )
}
